"use client"

import { config } from "@/shared/utils/config"
import Turnstile, { BoundTurnstileObject } from "react-turnstile"
import { createContext, useCallback, useRef, useState } from "react"

type TurnstileContextType = {
  getToken: () => string | null
  resetToken: () => void
  isReady: boolean
}

export const TurnstileContext = createContext<TurnstileContextType>({
  getToken: () => null,
  resetToken: () => undefined,
  isReady: false,
})

export const TurnstileProvider = ({ children }: { children: React.ReactNode }) => {
  const tokenRef = useRef<string | null>(null)
  const boundTurnstileRef = useRef<BoundTurnstileObject | null>(null)
  const [isReady, setIsReady] = useState(false)

  const getToken = useCallback(() => tokenRef.current, [])

  const resetToken = useCallback(() => {
    tokenRef.current = null
    setIsReady(false)
    boundTurnstileRef.current?.reset()
  }, [])

  return (
    <TurnstileContext.Provider value={{ getToken, resetToken, isReady }}>
      {children}
      <Turnstile
        sitekey={config.TURNSTILE_SITE_KEY}
        onVerify={(token: string, boundTurnstile: BoundTurnstileObject) => {
          tokenRef.current = token
          boundTurnstileRef.current = boundTurnstile
          setIsReady(true)
        }}
        onExpire={() => {
          tokenRef.current = null
          setIsReady(false)
        }}
        onError={() => {
          tokenRef.current = null
          setIsReady(false)
        }}
        size="invisible"
        retry="auto"
        refreshExpired="auto"
      />
    </TurnstileContext.Provider>
  )
}
